/**
 * Simple tooth event dispatcher.
 * Passive hook - no side effects, only event emission.
 */

import type { ToothEvent } from "../types/domain";

type ToothEventListener = (_event: ToothEvent) => void;

const listeners = new Set<ToothEventListener>();

/**
 * Emit a tooth event to all registered listeners.
 */
export function emitToothEvent(event: ToothEvent): void {
  listeners.forEach((listener) => {
    try {
      listener(event);
    } catch (error) {
      // Don't break other listeners
      console.error("ToothEventBus listener error:", error);
    }
  });
}

/**
 * Subscribe to tooth events.
 * @returns Unsubscribe function
 */
export function subscribeToothEvent(listener: ToothEventListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
